<div class="user-select-none bg-body-tertiary rounded rounded-2 border-light-subtle d-flex flex-fill w-100 h-100" [ngClass]="containerWidth > 0 ? 'p-0' : 'justify-content-center align-items-center p-3'">
    <div
        #canvas
        class="user-select-none rounded rounded-2 border-light-subtle position-relative"
        [style.height.px]="height > 0 ? height : null"
        [style.width]="(containerWidth > 0 && width > 0) ? width + 'px' : '100%'"
        [style.background-size]="(null | scale : xScale) / floorDimensions.width + 'px ' + (null | scale : yScale) / floorDimensions.height + 'px'"
        [style.background-position]="(null | scale : xScale) / floorDimensions.width + 'px ' + (null | scale : yScale) / floorDimensions.height + 'px'"
        [style.background-image]="'radial-gradient(circle, #B5BDC0 1px, transparent 1px)'"
        data-testid="floor-plan"
        (mousedown)="onMouseDown($event)"
        (touchstart)="onTouchStart($event)"
        (mousemove)="onMouseMove($event)"
        (touchmove)="onTouchMove($event)"
        (mouseup)="onMouseUp($event)"
        (touchend)="onTouchEnd($event)"
    >
        <app-floor-tables
            class="position-absolute top-0 start-0 h-100 w-100"
            [tableViewModels]="tableViewModels"
            [xScale]="xScale"
            [yScale]="yScale"
            [mouseEvents$]="mouseEvents$"
            [venue]="venue"
            (bookingHover)="onBookingHover($event)"
        >
        </app-floor-tables>
    </div>
</div>
